import React, { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { auth } from "../firebaseConfig";

const PrivateRoute = () => {
  const { user, loading } = useAuth();

  useEffect(() => {
    // Add auth state listener
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        // Force token refresh on mount
        try {
          await user.getIdToken(true);
        } catch (error) {
          console.error("Token refresh failed:", error);
        }
      }
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  // Redirect if no user
  if (!user) {
    return <Navigate to="/signin" replace />;
  }

  // Render child routes if authenticated
  return <Outlet />;
};

export default PrivateRoute;